(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var contentId = 'CartDrawerContent';
  var cartCountEl = document.querySelector('[data-header-cart-count]');

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var newContent = parsed.getElementById(contentId);
        var oldContent = document.getElementById(contentId);
        if (newContent && oldContent) {
          oldContent.replaceWith(newContent);
        }
      })
      .catch(function (error) {
        console.warn('Unable to refresh cart drawer', error);
      });
  }

  function autoOpenEnabled() {
    return !window.cartDrawerSettings || window.cartDrawerSettings.autoOpen !== false;
  }

  function setLoading(cartItemEl, isLoading) {
    if (cartItemEl) cartItemEl.classList.toggle('is-loading', isLoading);
  }

  function updateHeaderCount(cart) {
    if (!cartCountEl) return;
    cartCountEl.setAttribute('data-header-cart-count', cart.item_count > 0 ? cart.item_count : '');
    cartCountEl.classList.toggle('visible', cart.item_count > 0);
  }

  function changeLineItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart);
        return refreshCartDrawer();
      });
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart);
        return refreshCartDrawer();
      });
  }

  // The theme's built-in quantity-selector/remove-link wiring only initializes
  // elements present at page load, so it never reaches drawer content injected
  // later via refreshCartDrawer(). Handle those interactions independently,
  // scoped to the drawer, via direct /cart/change.js calls.
  drawer.addEventListener('click', function (event) {
    var clearButton = event.target.closest('[data-cart-drawer-clear]');
    if (clearButton) {
      event.preventDefault();
      clearButton.disabled = true;
      clearCart();
      return;
    }

    var cartItemEl = event.target.closest('[data-cartitem-key]');
    if (!cartItemEl) return;

    var key = cartItemEl.dataset.cartitemKey;
    var input = cartItemEl.querySelector('.quantity-selector__input');

    var removeLink = event.target.closest('[data-cartitem-remove]');
    if (removeLink) {
      event.preventDefault();
      setLoading(cartItemEl, true);
      changeLineItem(key, 0);
      return;
    }

    var plusButton = event.target.closest('.quantity-selector__button--plus');
    var minusButton = event.target.closest('.quantity-selector__button--minus');
    if ((plusButton || minusButton) && input) {
      var currentQty = parseInt(input.value, 10) || 0;
      var newQty = plusButton ? currentQty + 1 : Math.max(0, currentQty - 1);
      setLoading(cartItemEl, true);
      changeLineItem(key, newQty);
    }
  });

  // Refresh drawer contents every time it's opened, from any trigger.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'open' && drawer.getAttribute('open') === 'true') {
        refreshCartDrawer();
      }
    });
  }).observe(drawer, { attributes: true });

  // Modern product-form component: cancel its default /cart redirect and open the drawer instead.
  document.addEventListener('product-form:cart:navigate', function (event) {
    if (!autoOpenEnabled()) return;
    event.preventDefault();
    drawer.open();
  });

  // Suppress the modern component's inline "added to cart" message when the
  // drawer is already giving that feedback (only when it will actually open).
  document.addEventListener('product-form:message:success', function (event) {
    if (!autoOpenEnabled()) return;
    event.preventDefault();
  });

  // Universal fallback: the header cart count updates on every add/remove/update
  // theme-wide, including via the legacy product-form component, which doesn't
  // dispatch the events above.
  if (cartCountEl) {
    new MutationObserver(function () {
      if (drawer.getAttribute('open') === 'true') {
        refreshCartDrawer();
      } else if (autoOpenEnabled()) {
        drawer.open();
      }
    }).observe(cartCountEl, { attributes: true });
  }
})();
